import { openDB } from "idb";

const STORE = "otb_version_drafts";
const DB_VERSION = 1;

function getDbName(tenantId) {
  return `aidron-otb-drafts__${tenantId}`;
}

function draftKey(userId, cycleId) {
  return `${userId}::${cycleId}`;
}

async function getDB(tenantId) {
  return openDB(getDbName(tenantId), DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "key" });
      }
    },
  });
}

/**
 * Recupera o draft de uma sessão de edição de OTB (todas as categorias
 * editadas ainda não salvas como versão), isolado por tenant/usuário/ciclo.
 * Retorna { editedByCategory, editedAnchors } ou null se não houver draft.
 */
export async function getOtbVersionDraft({ tenantId, userId, cycleId }) {
  const db = await getDB(tenantId);
  const result = await db.get(STORE, draftKey(userId, cycleId));
  if (!result) return null;
  return {
    editedByCategory: result.editedByCategory,
    editedAnchors: result.editedAnchors,
  };
}

/**
 * Grava (sobrescreve) o estado atual — editedByCategory (dado computado,
 * usado para preview) e editedAnchors (quais meses foram de fato editados
 * pelo usuário, usado para montar o payload de salvamento) — chamar com
 * debounce, não a cada tecla.
 */
export async function saveOtbVersionDraft({ tenantId, userId, cycleId, editedByCategory, editedAnchors }) {
  const db = await getDB(tenantId);
  return db.put(STORE, {
    key: draftKey(userId, cycleId),
    tenantId,
    userId,
    cycleId,
    editedByCategory,
    editedAnchors,
    updatedAt: Date.now(),
  });
}

/**
 * Remove o draft — chamar após "Salvar versão" confirmado pela API,
 * ou após "Descartar versão".
 */
export async function deleteOtbVersionDraft({ tenantId, userId, cycleId }) {
  const db = await getDB(tenantId);
  return db.delete(STORE, draftKey(userId, cycleId));
}